<!-- 
circle
https://mhweb.shmedia.tech/h5/mh/share/index.html?id=743b1aa0933b4ab19070f531755b3899f33d&type=community-article
 -->
<template>
  <div>
    <div class="header-line">
      <p>动态详情</p>
    </div>
    <div class="circle" id="main" @click="goUrl">
      <div class="top">
        <div class="avatar">
          <van-image
            round
            width="50px"
            height="50px"
            fit="cover"
            :src="view.poster.avatar.sourceUrl"
          />
        </div>
        <div class="persion">
          <div class="name">
            <p>{{ view.poster.nickname }}</p>
          </div>
          <div class="time">
            <p>{{ view.releaseDate.substring(0, 10) }}</p>
          </div>
        </div>
      </div>
      <div class="middle">
        <div class="content">
          <p>
            <span
              v-for="(item, index) in taglist"
              :key="index"
              style="color: red"
              >#{{ item.title }}#</span
            >{{ txt }}
          </p>
        </div>
        <div
          class="piclist"
          v-if="view.resources && view.resources[0].contentType !== 'video'"
        >
          <van-grid
            :column-num="
              view.resources.length > 3
                ? 3
                : view.resources.length == 1
                ? 1
                : view.resources.length == 4
                ? 2
                : view.resources.length
            "
            :border="false"
          >
            <van-grid-item
              class="picitem"
              :class="{ height100: length3 > 2 }"
              v-for="item in view.resources"
              :key="item.id"
            >
              <van-image :src="item.sourceUrl" fit="cover" />
            </van-grid-item>
          </van-grid>
        </div>
        <div
          class="piclist"
          v-else-if="view.resources && view.resources[0].contentType == 'video'"
        >
          <video :src="view.resources[0].sourceUrl" controls="controls"></video>
        </div>
        <div class="circlename" v-if="view.tribe.titleImage">
          <div class="circleavatar">
            <van-image
              class="circlepic"
              round
              width="38px"
              height="38px"
              fit="cover"
              :src="view.tribe.titleImage.sourceUrl"
            />
          </div>
          <div class="circledetail" v-if="view.tribe.count">
            <div class="circletitle">
              <div class="name">
                <p>{{ view.tribe.title }}</p>
              </div>
              <div class="time">
                <p>{{ view.tribe.count.fansCount }}人已加入</p>
              </div>
            </div>
            <div class="right">
              <img src="../assets/images/right.png" alt="" />
            </div>
          </div>
        </div>
      </div>
      <div class="comment"></div>
      <bottom @envChange="envChange" />
    </div>
  </div>
</template>

<script>
import bottom from "./bottom";
export default {
  name: "circleDetail",
  components: {
    bottom,
  },
  props: {
    view: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {
      origin: "",
      taglist: [],
      txt: "",
      type: "",
    };
  },
  mounted() {
    this.getView();
  },
  methods: {
    // 详情
    getView() {
      // if(this.view !== {}) {
      // }
      if (this.view.topics && this.view.topics.length > 0) {
        this.taglist = this.view.topics;
        document.getElementsByTagName("title")[0].innerText = this.view
          .topics[0].title
          ? "#" + this.view.topics[0].title + "#"
          : "圈子分享";
      }
      if (this.view.content) {
        this.txt = this.view.content.replace(/\[tag(.*?)\]/gi, "");
      }
    },
    envChange(e) {
      this.$emit("envChange", e);
    },
    goUrl() {
      if (this.isWeixin.in) {
        this.isWeixin.show = true;
        this.$emit("envChange", this.isWeixin);
        return;
      }
      if (window.navigator.userAgent.indexOf("iPhone") > -1) {
        // setTimeout(() =>{
        //   window.location.href = this.site.iosUrl // ios 下载
        // }, 1000)
        this.jieliuF(this.site.appIosUrl);
      } else {
        // setTimeout(() =>{
        //   window.location.href = this.site.anUrl // 安卓 下载
        // }, 1000)
        this.jieliuF(this.site.appAnUrl);
      }
    },
    jieliuF(url) {
      const me = this;
      this.jieliuhanshu(me.goApp(url), 1500);
    },
    goApp(url) {
      window.location.href = url; // 唤起app
      // setTimeout( () => {
      //   window.location.href = url // 唤起app
      // }, 500)
    },
  },
};
</script>
<style>
@import "../../node_modules/vant/lib/index.css";
</style>
<style>
body {
  background-color: #f2f2f2;
}
img {
  height: inherit !important;
}
</style>
<style lang="less" scoped>
p {
  margin-bottom: 0;
}
/deep/ .van-grid-item__content {
  padding: 0 3px;
}
.header-line {
  height: 65px;
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: white;
  p {
    color: #203152;
    font-size: 20px;
    font-weight: bold;
  }
}
.circle {
  padding: 30px 15px;
  .top {
    padding: 0 15px;
    display: flex;
    .avatar {
      padding-right: 15px;
    }
    .persion {
      display: flex;
      flex-direction: column;
      justify-content: center;
      .name p {
        font-size: 17px;
        font-weight: bold;
      }
      .time p {
        font-size: 12px;
        color: #b1b1b1;
      }
    }
  }
  .middle {
    background: white;
    border-radius: 12px;
    display: block;
    padding-bottom: 20px;
    .content {
      color: #203152;
      padding: 15px 15px 5px 7px;
      font-size: 17px;
      word-break: break-all;
    }
    .piclist {
      padding: 0 7px;
      max-width: 100%;
      .picitem {
        margin-bottom: 5px;
      }
      /deep/ .picitem img {
        border-radius: 13px;
      }
      /deep/ .van-image {
        height: 100% !important;
      }
      .height100 {
        /deep/ .van-image {
          height: 100px !important;
        }
      }
    }
    .circlename {
      display: flex;
      border-radius: 20px;
      margin: 15px;
      border: 1px solid #d1dce2;
      .circleavatar {
        display: flex;
        margin-right: 5px;
        align-items: center;
        .circlepic {
          margin: 3px;
        }
      }
      .circledetail {
        display: flex;
        width: 100%;
        justify-content: space-between;
        .circletitle {
          display: flex;
          flex-direction: column;
          justify-content: center;
          height: 100%;
          .name p {
            font-size: 15px;
            font-weight: bold;
          }
          .time p {
            font-size: 10px;
            color: #b1b1b1;
          }
        }
        .right {
          margin: auto 8px;
        }
      }
    }
  }
}
</style>